module.exports = __webpack_public_path__ + "static/img/claro-logo.35031082.png";